@if (contactsData$ | async; as contactsData) { @if (contactsData.total > 0) {
<div
  [atxPopover]="popContent"
  triggers="manual"
  [autoClose]="false"
  (click)="openUserMenu()"
  class="d-flex align-items-center h-100"
>
  <div class="avatars">
    @for (avatar of contactsData.avatars; track avatar) {
    <atx-avatar
      size="s"
      [fullName]="avatar.displayName"
      [connectionStatus]="avatar.connectionStatus"
      [image]="avatar.imageLink"
    ></atx-avatar>
    }
  </div>
  @if (contactsData.showContactsNumber) {
  <h5 class="text-muted font-weight-normal mb-0">
    +{{ contactsData.contactsNumber }}
  </h5>
  }
</div>
} }

<ng-template #popContent>
  <epc-connect-call-notification
    [contact]="contactCalling$ | async"
    (accept)="acceptCall()"
    (decline)="declineCall($event)"
  ></epc-connect-call-notification>
  <audio loop autoplay>
    <source src="assets/media/call.mp3" type="audio/mpeg" />
  </audio>
</ng-template>
